import { ruleRunner } from 'validations/ruleRunner';
import { required, minimun } from 'validations/rules';

const Validations = [ruleRunner('price', 'preço', required, minimun('1.00'))];

export default Validations;
